import Logo from "../../Images/newlogo1-01.png";
import { Avatar, Result } from "antd";
import "./TeamSelection.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectManagerTeam } from "../../store/actions/manager.actions";
import { useEffect } from "react";

export const TeamSelection = () => {
  const dispatch = useDispatch();
  const { teams, selectedTeam } = useSelector(({ manager }) => manager);
  const navigate = useNavigate();
  
  const location = useLocation();
  const searchQuery = location.search || "";  

  const handleSelectTeam = async (team) => {
    const valid = await dispatch(selectManagerTeam(team.id, navigate));
    if (valid) {
      navigate("/overview" + searchQuery);
    }
  };

  useEffect(() => {
    if (teams.length === 1) {
      if (selectedTeam) {
        navigate("/overview" + searchQuery);
      } else {
        handleSelectTeam(teams[0]);
      }
    }
  }, [teams]);

  return (
    <div style={{ display: "flex", justifyContent: "center", height: "100vh" }}>
      <div
        style={{
          width: 500,
          marginTop: "10%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={Logo} style={{ width: "50%" }} />

        {teams.length == 0 ? (
        <Result
          status="warning"
          title="You do not have access to any teams on the GPS DataViz Web Platform."
          extra={
            "If you are an athlete, you may have access to the GPS DataViz mobile app if your coach has signed you up."
          }
        />
        ) : (<>
        <h4 style={{ margin: "24px 0px" }}>Select Your Team</h4>

        <h6>Select your team to manage your training</h6>

        <div style={{ marginTop: 24, width: "100%" }}>
          {teams.map((team) => (
            <div
              className="team-item"
              onClick={() => handleSelectTeam(team)}
              key={team.id}
            >
              <Avatar src={team.team_logo} style={{ width: 72, height: 72 }} />
              <h5 style={{ flex: 1 }}>{team.display_name}</h5>
            </div>
          ))}
        </div>
        </>
        )
      }
      </div>
    </div>
  );
};
